import { FC } from 'react'
import { useCustomTheme } from '@/core/theme'
import SvgLogo from '@/ui/components/svg/logo'
import { SecurityTip } from './SecurityTip'
import {
    ArcSvg,
    EyebrowRow,
    EyebrowText,
    IndicatorBox,
    LogoWrap,
    Screen,
    Wordmark,
} from './LoadingScreen.styles'

const ARC_SIZE = 168
const RING_STROKE = 1
const ARC_STROKE = 2
const ARC_RADIUS = 78

const LoadingScreen: FC = () => {
    const theme = useCustomTheme()

    return (
        <Screen data-testid="loading-screen">
            <EyebrowRow>
                <EyebrowText variant="xs-bold">At-Bay · Stance</EyebrowText>
            </EyebrowRow>

            <Wordmark variant="xxxl-light" component="h1">
                Stance
            </Wordmark>

            <IndicatorBox size={ARC_SIZE} role="status" aria-label="Loading">
                <ArcSvg
                    viewBox={`0 0 ${ARC_SIZE} ${ARC_SIZE}`}
                    width={ARC_SIZE}
                    height={ARC_SIZE}
                >
                    <circle
                        cx={ARC_SIZE / 2}
                        cy={ARC_SIZE / 2}
                        r={ARC_RADIUS}
                        fill="none"
                        stroke={theme.colors.greys[100]}
                        strokeWidth={RING_STROKE}
                    />
                    <circle
                        cx={ARC_SIZE / 2}
                        cy={ARC_SIZE / 2}
                        r={ARC_RADIUS}
                        fill="none"
                        stroke={theme.colors.primary[200]}
                        strokeWidth={ARC_STROKE}
                        strokeLinecap="round"
                        strokeDasharray="120 360"
                        strokeDashoffset="360"
                    />
                </ArcSvg>

                <LogoWrap>
                    <SvgLogo
                        width={46}
                        height={26}
                        primaryColor={theme.colors.greys[800]}
                        secondaryColor={theme.colors.primary[200]}
                    />
                </LogoWrap>
            </IndicatorBox>

            <SecurityTip />
        </Screen>
    )
}

export default LoadingScreen
